module.exports = __webpack_public_path__ + "static/media/banner-4.f89ce7fc.png";